import React from "react";

const StarRating = ({ filled = 0, total = 5, size = 20, color = "#f90" }) => {
  const stars = Array.from({ length: total }, (_, i) => {
    const isFilled = i < filled;
    const colorFilled = isFilled ? "currentColor": '#9f9f9f';
    const path = isFilled
      ? "m12 16.102l-3.63 2.192q-.16.079-.297.064q-.136-.016-.265-.094q-.13-.08-.196-.226t-.012-.319l.966-4.11l-3.195-2.77q-.135-.11-.178-.263t.019-.293t.165-.23q.104-.087.28-.118l4.216-.368l1.644-3.892q.068-.165.196-.238T12 5.364t.288.073t.195.238l1.644 3.892l4.215.368q.177.03.281.119q.104.088.166.229q.061.14.018.293t-.178.263l-3.195 2.77l.966 4.11q.056.171-.011.318t-.197.226q-.128.08-.265.095q-.136.015-.296-.064z"
      : "m8.85 16.825l3.15-1.9l3.15 1.925l-.825-3.6l2.775-2.4l-3.65-.325l-1.45-3.4l-1.45 3.375l-3.65.325l2.775 2.425zm3.15-.723l-3.63 2.192q-.16.079-.297.064q-.136-.016-.265-.094q-.13-.08-.196-.226t-.012-.319l.966-4.11l-3.195-2.77q-.135-.11-.178-.263t.019-.293t.165-.23q.104-.087.28-.118l4.216-.368l1.644-3.892q.068-.165.196-.238T12 5.364t.288.073t.195.238l1.644 3.892l4.215.368q.177.03.281.119q.104.088.166.229q.061.14.018.293t-.178.263l-3.195 2.77l.966 4.11q.056.171-.011.318t-.197.226q-.128.08-.265.095q-.136.015-.296-.064zm0-3.852";

    return (
      <span
        key={i}
        style={{ display: "inline-block", lineHeight: 0, padding: 0, margin: 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          style={{ display: "block", color, marginRight: '-7px' }}
        >
          <path fill={colorFilled} d={path} />
        </svg>
      </span>
    );
  });

  return (
    <div style={{ display: "flex", padding: 0, margin: 0, gap: 0, alignItems: "center" }}>
      {stars}
    </div>
  );
};

export default StarRating;